import React, { useMemo } from "react";
import LiveVideoPlayer from "./video/LiveVideoPlayer";

// Backwards-compatible entry point for the live-dealer video surface.
//
// Legacy callers pass `url` (a stream_url string) and keep working unchanged —
// the provider (YouTube/Twitch/HLS/WebRTC/iframe) is auto-detected.
// Newer callers pass `config` = { stream_url|url, video_provider, fallback_stream_url }
// to make the provider + fallback explicit. All rendering, provider selection,
// fallback, and health handling now live in the video/ provider abstraction.
export default function LiveDealerVideo({ url, config, className = "", chrome = true, onHealth, muted = true }) {
  const resolved = useMemo(() => (config != null ? config : { url }), [config, url]);
  return <LiveVideoPlayer config={resolved} className={className} chrome={chrome} onHealth={onHealth} muted={muted} />;
}
